import { Voni } from '../client';
import { WidgetSettings } from '../types';

export interface Project {
  id: string;
  name: string;
  project_type: string;
  widget_settings?: WidgetSettings;
  created_at: string;
  updated_at: string;
}

export interface ProjectUpdateInput {
  name?: string;
  projectType?: string;
  widgetSettings?: WidgetSettings;
}

export class ProjectResource {
  constructor(private client: Voni) {}

  async list(): Promise<Project[]> {
    return this.client.request<Project[]>('GET', '/projects/');
  }

  async get(projectId: string): Promise<Project> {
    return this.client.request<Project>('GET', `/projects/${projectId}`);
  }

  async create(name: string, projectType: string = 'assistant', widgetSettings?: WidgetSettings): Promise<Project> {
    const data: Record<string, unknown> = { 
      name,
      project_type: projectType 
    };
    if (widgetSettings) {
      data.widget_settings = widgetSettings;
    }
    return this.client.request<Project>('POST', '/projects/', undefined, data);
  }

  async update(projectId: string, updates: ProjectUpdateInput): Promise<Project> {
    const data: Record<string, unknown> = {};
    if (updates.name) data.name = updates.name;
    if (updates.projectType) data.project_type = updates.projectType;
    if (updates.widgetSettings) data.widget_settings = updates.widgetSettings;
    
    return this.client.request<Project>('PUT', `/projects/${projectId}`, undefined, data);
  }

  async delete(projectId: string): Promise<boolean> {
    await this.client.request('DELETE', `/projects/${projectId}`);
    return true;
  }
}
